/**
 * exam-manager.js

 * 概述:
 * 题目信息查询类
 *
 * API:

 * @author changh 2018/4/28
 */
import axios from 'axios'
import setConfig from '@/config/axios-config'
setConfig(axios)

const basePath = '/ItemServer'
// const basePath = '/ItemService'//20240710黄骏泳修改(开发阶段需要)
const basePathNew = '/ItemService'
const axiosConfig = {
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }}
/**
 * 查询题目信息
 * @author changh 2018-05-04T11:12:02+0800
 * @param  {Object} params {
      "data": {
        "examId": "string",
        "subjectId": "string"
      }
    }
 * @return {[type]}        [description]
 */
const getItemInfo = (params = {}) => {
  return axios.post(`${basePathNew}/getItem`, params).then(res => res.data)
}
/**
 * 查询题目结构
 * @author chenxb 2020-06-04T11:12:02+0800
 * @param  {Object} params [description]
 * @return {[type]}        [description]
 */
const getItemStructure = (data) => {
  let urlParam = `flag=getItemStructure&app=getItemStructure&json=${JSON.stringify(data)}`
  return axios.post(`${basePath}/item.jsp`, urlParam, axiosConfig).then(res => res.data)
}
/**
 * 查询题目坐标信息
 * @author changh 2018-05-04T11:12:02+0800
 * @param  {Object} params [description]
 * @return {[type]}        [description]
 */
const queryItem = (data) => {
  let urlParam = `flag=queryItem&app=queryItem&json=${JSON.stringify(data)}`
  return axios.post(`${basePath}/item/queryItem`, urlParam, axiosConfig).then(res => res.data)
}
/**
 * 查询题目信息-新
 * @author  lyc
 * @param  {Object} params [description]
 * @return {[type]}        [description]
 */
const getItemsBySubject = (params = {}) => {
  return axios.post(basePathNew + '/getItemsBySubject', params)
    .then(res => res.data)
}

/**
 * 查询cardMould
 * @author  lyc
 * @param  {Object} params [description]
 * @return {[type]}        [description]
 */
const getCardMould = (params = {}) => {
  return axios.post(basePathNew + '/getCardMould', params)
    .then(res => res.data)
}

/**
 * 保存题卡标答给分信息-新
 * @author  lyc
 * @param  {Object} params [description]
 * @return {[type]}        [description]
 */
const setItem = (data) => {
  return axios.post(basePathNew + '/setItem', data).then(res => res.data)
}

/**
 * 查询模板地址
 * @author wangk 2018-11-19T17:22:12+0800
 * @param  {Object} params {"examId":"1542619130226","subjects":["1525835962893"]}
 * @return {[type]}        [description]
 */
const querySeaTemplate = (params = {}) => {
  // 注意: 这里 app 和 flag 都是 querySeaTemplete, 不是 querySeaTemplate
  let urlParams = 'app=querySeaTemplete&flag=querySeaTemplete&json=' + JSON.stringify(params)
  return axios.post(`${basePath}/item.jsp`, urlParams, axiosConfig)
    .then(res => res.data)
}

/**
 * 查询上传地址
 * @author wangk 2018-11-20T17:31:19+0800
 * @param  {Object} params [description]
 * @return {[type]}        [description]
 */
const querySeaUploadUrl = (params = {}) => {
  let urlParams = 'app=mould_sea&flag=getURL&json={}'
  return axios.post(`${basePath}/sea.jsp`, urlParams, axiosConfig)
    .then(res => res.data)
}

/**
 * 查询原题卡信息(现有题卡信息)
 * @author wangk 2018-11-19T16:58:37+0800
 * @param  {Object} params {"examId":"1540550134695","subjectId":"1525835962893"}
 * @return {[type]}        [description]
 */
const getUseModelList = (params = {}) => {
  let urlParams = 'app=GetUseModelList&flag=GetUseModelList&json=' + JSON.stringify(params)
  return axios.post(`${basePath}/item.jsp`, urlParams, axiosConfig)
    .then(res => res.data)
}

/**
 * 查询新题卡信息
 * @author wangk 2018-11-19T16:59:57+0800
 * @param  {Object} params {"examId":"1540550134695","subjectId":"1525835962893"}
 * @return {[type]}        [description]
 */
const getModelInfo = (params = {}) => {
  let urlParams = 'app=GetModelInfo&flag=getModelList&json=' + JSON.stringify(params)
  return axios.post(`${basePath}/item.jsp`, urlParams, axiosConfig)
    .then(res => res.data)
}

/**
 * 保存题卡信息
 * @author wangk 2018-11-20T14:19:31+0800
 * @param  {Object} params { "orgId":"1525835962859","examId":"1542619130226","subjectId":"1525835962893","subjectName":"信息技术" }
 * @return {[type]}        [description]
 */
const saveModelInfo = (params = {}) => {
  let urlParams = 'app=importMould&flag=importMould&json=' + JSON.stringify(Object.assign({
    file: '', xml: ''
  }, params))
  return axios.post(`${basePath}/item/importMould`, urlParams, axiosConfig)
    .then(res => res.data)
}

/**
 * 科目拆分
 * @author changh 2018-05-04T11:12:02+0800
 * @param  {Object} params [description]
 * @return {[type]}        [description]
 */
const getItemClass = (data) => {
  let urlParam = `app=getItemClass&flag=getItemClass&json=${JSON.stringify(data)}`
  return axios.post(`${basePath}/item.jsp`, urlParam, axiosConfig).then(res => res.data)
}
/**
 * 查询科目拆分结果
 * @author changh 2018-05-04T11:12:02+0800
 * @param  {Object} params [description]
 * @return {[type]}        [description]
 */
const updateItemClass = (data) => {
  let urlParam = `app=updateItemClass&flag=updateItemClass&json=${JSON.stringify(data)}`
  return axios.post(`${basePath}/item.jsp`, urlParam, axiosConfig).then(res => res.data)
}
/**
 * 上传双向细目表图像
 * @author changh 2020-05-04T11:12:02+0800
 * @param  {Object} params [description]
 * @return {[type]}        [description]
 */
const uploadPaperPic = (data) => {
  return axios({ method: 'POST', url: `${basePathNew}/uploadPaperPic`, data: data }).then(res => res.data)
}
/**
 * 查询双向细目表图像
 * @author changh 2020-05-04T11:12:02+0800
 * @param  {Object} {
    {
      "data": {
        "examId": "string",
        "subjectId": "string",
        "type": 0
      },
      "pageNum": 0,
      "pageSize": 0,
      "token": "string",
      "userInfo": "string"
    } [description]
 * @return {[type]}        [description]
 */
const queryPaperPic = (data) => {
  return axios.post(`${basePathNew}/queryPaperPic`, data)
    .then(res => res.data)
}
/**
 * 删除双向细目表图像
 * @author changh 2020-05-04T11:12:02+0800
 * @param  {Object} {
    {
      "data": {
        "id": 0
      },
      "pageNum": 0,
      "pageSize": 0,
      "token": "string",
      "userInfo": "string"
    } [description]
 * @return {[type]}        [description]
 */
const delPaperPic = (data) => {
  return axios.post(`${basePathNew}/delPaperPic`, data)
    .then(res => res.data)
}
/**
 * 查询双向细目表题目明细
 * @author changh 2020-05-04T11:12:02+0800
 * @param  {Object}{
    {
      "data": {
        "examId": "string",
        "subjectId": "string"
      },
      "pageNum": 0,
      "pageSize": 0,
      "token": "string",
      "userInfo": "string"
    } [description]
 * @return {[type]}        [description]
 */
const queryItemPoint = (data) => {
  return axios.post(`${basePathNew}/queryItemPoint`, data)
    .then(res => res.data)
}

/**
 * 保存双向细目表题目明细
 * @author changh 2020-05-04T11:12:02+0800
 * @param  {Object}[
  {
    "analyse": [
      {
        "cut": "string",
        "seq": 0,
        "sid": 0
      }
    ],
    "content": [
      {
        "cut": "string",
        "seq": 0,
        "sid": 0
      }
    ],
    "degree": "string",
    "examId": "string",
    "itemId": "string",
    "itemType": "string",
    "itemTypeId": "string",
    "itemTypeName": "string",
    "points": [
      {
        "pointId": "string",
        "pointName": "string"
      }
    ],
    "subjectId": "string",
    "subname": "string"
  }
] [description]
 * @return {[type]}        [description]
 */
const saveItemPoint = (data) => {
  console.log(data)
  return axios.post(`${basePathNew}/saveItemPoint`, data)
    .then(res => res.data)
}

/**
 * 设置评卷方案
 * @author changh 2020-05-04T11:12:02+0800
 * @param  {Object}
* {
    data": [
      {
        "examId": "string",
        "name": "string",
        "subjectId": "string",
        "subjectName": "string"
        "alias": "string",
        "autoMarking": "string",
        "autoMarkingCalcuScore": "string",
        "detail": {
          "subItem": [
            {
              "alias": "string",
              "scoreStr": "string",
              "subName": "string"
            }
          ]
        }
      }
    ]
  }
  [description]
 * @return {[type]}        [description]
 */
const setScheme = (data) => {
  console.log(data)
  return axios.post(`${basePathNew}/setScheme`, data)
    .then(res => res.data)
}

/**
 * 导出评卷参数
 * @author hjy 20240710
 * @param  {Object}
* {
    "examId": "string",
    "subjectId": "string",
  }
 * @return {[type]}        [description]
 */
const exportReadParam = (data) => {
  return axios.post(`${basePathNew}/exportScheme`, data)
  .then(res => res.data)
}

/**
 * 导入评卷参数
 * @author hjy 20240710
 * @param  {Object}
* {
    "examId": "string",
    "subjectId": "string",
  }
 * @return {[type]}        [description]
 */
  const importReadParam = (data) => {
    return axios.post(`${basePathNew}/importScheme?json=${JSON.stringify(data.data)}`, data.file)
    .then(res => res.data)
  }

/**
 * 查询模版图像地址，用于主观题画块
 * @author changh 2020-09-11T11:12:02+0800
 * @param  {Object}
* {
    "examId": "string",
    "subjectId": "string",
  }
 * @return {[type]}        [description]
 */
const getTemplateImage = (data) => {
  let urlParam = `app=getTemplateImage&flag=getUrl&json=${JSON.stringify(data)}`
  return axios.post(`${basePath}/seaimage.jsp`, urlParam, axiosConfig).then(res => res.data)
}
/**
 * 查询多选题组信息，题组选项坐标
 * @author changh 2020-09-11T11:12:02+0800
 * @param  {Object}
* {
    "examId": "string",
    "subjectId": "string",
  }
 * @return {[type]}        [description]
 */
const getChooseList = (data) => {
  let urlParam = `app=getChooseList&flag=getChooseList&json=${JSON.stringify(data)}`
  return axios.post(`${basePath}/item/getChooseList`, urlParam, axiosConfig).then(res => res.data)
}
/**
 * 主观题画块，新增主观题
 * @author changh 2020-09-11T11:12:02+0800
 * @param  {Object}
 *{"examId":"1592360170259","subjectId":"1571124943174",
    "items":[{"id":"","isChoose":"true",
    "itemCuts":[{"cutIndex":4,"position":{"cardNo":"1","face":"1","x1":1,"x2":601,"y1":1035,"y2":1208,"rotate":"0"}}],"itemID":["90","91","92","30000"],"itemName":""}]}
 * @return {[type]}        [description]
 */
const addItem = (data) => {
  let urlParam = `app=addItem&flag=addItem&json=${JSON.stringify(data)}`
  return axios.post(`${basePath}/item/addItem`, urlParam, axiosConfig).then(res => res.data)
}
/**
 * 主观题画块，删除主观题
 * @author changh 2020-09-11T11:12:02+0800
 * @param  {Object}
 *{"examId":"1592360170259","subjectId":"1571124943174","id":"26","sid":""}
 * @return {[type]}        [description]
 */
const deleteItem = (data) => {
  let urlParam = `app=deleteItem&flag=deleteItem&json=${JSON.stringify(data)}`
  return axios.post(`${basePath}/item/deleteItem`, urlParam, axiosConfig).then(res => res.data)
}
/**
 * 主观题画块，修改主观题
 * @author changh 2020-09-11T11:12:02+0800
 * @param  {Object}
 *{"examId":"1592360170259","subjectId":"1571124943174","items":[{"id":"29","itemID":["29"],"itemName":"","isChoose":"false","itemCuts":[{"cutIndex":"1","position":{"cardNo":"1","face":"1","x1":138,"y1":273,"x2":466,"y2":523,"rotate":"0"}}]}]}
 * @return {[type]}        [description]
 */
const updateItem = (data) => {
  let urlParam = `app=updateItem&flag=updateItem&json=${JSON.stringify(data)}`
  return axios.post(`${basePath}/item/updateItem`, urlParam, axiosConfig).then(res => res.data)
}

/**
 * 主观题画块，修改主观题画块状态
 * @author changh 2020-09-11T11:12:02+0800
 * @param  {Object}
 *{"examId":"1592360170259","subjectId":"1571124943174","subjectName":"文数"}
 * @return {[type]}        [description]
 */
const updateZgSetupMonitor = (data) => {
  let urlParam = `app=updateZgSetupMonitor&flag=updateZgSetupMonitor&json=${JSON.stringify(data)}`
  return axios.post(`${basePath}/item/updateZgSetupMonitor`, urlParam, axiosConfig).then(res => res.data)
}

/**
 * 查询考试绑定菁优试卷
 * @author changh 2020-05-04T11:12:02+0800
 * @param  {Object}
* {
    data: {
      examId: '123',
      subjectId: '123'
    }
  }
  [description]
 * @return {[type]}
 {
    result: 'true',
    data: {
      paperId: ['','']
    }
    errorCode： "",
    errorMsg: ""
  }
 */
const listBindPaper = (data) => {
  return axios.post(`${basePathNew}/listBindPaper`, data)
    .then(res => res.data)
}

/**
 * 查询是否开启评卷任务量设置
 * @author changh 2021-04-04T11:12:02+0800
 * @param  {Object}
  [description]
  {
    'data': {
      'examId: '123',
      'subjectId': '123'
    }
  }
 * @return {[type]}
 {
    'data': {
        'pjNumShow': true
      }
  }
 */
const getPjNumShow = (data) => {
  return axios.post(`${basePathNew}/getPjNumShow`, data)
    .then(res => res.data)
}

/**
 * 查询题目评卷任务量
 * @author changh 2021-04-04T11:12:02+0800
 * @param  {Object}
  [description]
  {
    'data': {
      'examId: '123',
      'subjectId': '123',
      'divId': '123'
    }
  }
 * @return {[type]}
 {
    'data': {
        'pjNum': 0
      }
  }
 */
const getPjNum = (data) => {
  return axios.post(`${basePathNew}/getPjNum`, data)
    .then(res => res.data)
}
/**
 * 查询科目是否开启自动回收任务
 * @author changh 2021-04-04T11:12:02+0800
 * @param  {Object}
  [description]
  {
    'data': {
      'examId: '123',
      'subjectId': '123'

      }
  }
 * @return {[type]}
 {
    'data': {
        'enableReclaim': 0
      }
  }
 */
const getEnableReclaim = (data) => {
  return axios.post(`${basePathNew}/getEnableReclaim`, data)
    .then(res => res.data)
}

/**
 * 查询画块信息
 * @author changh 2021-04-04T11:12:02+0800
 * @param  {Object}
  [description]
  {
    data: {
      examId: '123',
      subjectId: '123',
      type:1,
    }
  }
 * @return {[type]}
 {
    result:true,
    data: {
      examId: '123',
      subjectId: '123',
      type:1,
      blocks: [
        {
          imageIndex:0, // 位于图像的索引
          position:{
            x:0,
            y:0,
            w:0,
            h:0,
          }
        }
      ]
    }
  }
 */
const getBlockInfo = (data) => {
  return axios.post(`${basePathNew}/getBlockInfo`, data)
    .then(res => res.data)
}

/**
 * 查询画块信息
 * @author changh 2021-04-04T11:12:02+0800
 * @param  {Object}
  [description]
  {
    data: {
      examId: '123',
      subjectId: '123',
      type:1,
    }
  }
 * @return {[type]}
 {
    result:true,
    data: {
      examId: '123',
      subjectId: '123',
      type:1,
      blocks: [
        {
          imageIndex:0, // 位于图像的索引
          position:{
            x:0,
            y:0,
            w:0,
            h:0,
          }
        }
      ]
    }
  }
 */
const setBlockInfo = (data) => {
  return axios.post(`${basePathNew}/setBlockInfo`, data)
    .then(res => res.data)
}

export {
  getItemInfo,
  getItemStructure,
  queryItem,
  querySeaTemplate,
  querySeaUploadUrl,
  getUseModelList,
  getModelInfo,
  saveModelInfo,
  getItemsBySubject,
  setItem,
  getCardMould,
  getItemClass,
  updateItemClass,
  uploadPaperPic,
  queryPaperPic,
  delPaperPic,
  queryItemPoint,
  saveItemPoint,
  setScheme,
  exportReadParam,
  importReadParam,
  getTemplateImage,
  getChooseList,
  addItem,
  deleteItem,
  updateItem,
  updateZgSetupMonitor,
  listBindPaper,
  getPjNumShow,
  getPjNum,
  getEnableReclaim,
  getBlockInfo,
  setBlockInfo
}



// WEBPACK FOOTER //
// ./src/model/item-model.js